import {
  UPDATE_PARTNER_SITE,
  UPDATE_SEGMENT,
  UPDATE_LINE,
  UPDATE_PARTNER_NAME,
  UPDATE_ODM,
  UPDATE_CUSTOMER_CLASS,
  UPDATE_AE_REGION,
  FETCH_AE_REGION_START,
  FETCH_AE_REGION_SUCCESS,
  FETCH_AE_REGION_ERROR,
  UPDATE_SEGMENT_LIST,
  UPDATE_LINE_LIST,
  FETCH_SEGMENT_LINE,
  FETCH_SEGMENT_LINE_START,
  FETCH_SEGMENT_LINE_SUCCESS,
  FETCH_SEGMENT_LINE_ERROR,
  UPDATE_PARTNER_SITE_LIST,
  FETCH_PARTNER_SITES,
  FETCH_PARTNER_SITES_START,
  FETCH_PARTNER_SITES_SUCCESS,
  FETCH_PARTNER_SITES_ERROR,
  POST_PARTNER_SITE,
  POST_PARTNER_SITE_START,
  POST_PARTNER_SITE_SUCCESS,
  POST_PARTNER_SITE_ERROR,
  FETCH_AE_REGION_LIST,
  FETCH_AE_REGION_LIST_START,
  FETCH_AE_REGION_LIST_SUCCESS,
  FETCH_AE_REGION_LIST_ERROR,
  UPDATE_AE_REGION_LIST
} from './constants'

import {
  segmentSelector,
  lineSelector,
} from './selectors'

const updatePartnerSite = (site) => ({ type: UPDATE_PARTNER_SITE, site })
const updateSegment = (seg) => ({ type: UPDATE_SEGMENT, seg })
const updateLine = (line) => ({ type: UPDATE_LINE, line })
const updatePartnerName = (name) => ({ type: UPDATE_PARTNER_NAME, name })
const updateOdm = (odm) => ({ type: UPDATE_ODM, odm })
const updateCustomerClass = (customerClass) => ({ type: UPDATE_CUSTOMER_CLASS, customerClass })

const updateAeRegion = (aeRegion) => ({ type: UPDATE_AE_REGION, aeRegion })
const fetchAeRegionStart = () => ({ type: FETCH_AE_REGION_START })
const fetchAeRegionSuccess = () => ({ type: FETCH_AE_REGION_SUCCESS })
const fetchAeRegionError = (error) => ({ type: FETCH_AE_REGION_ERROR, error })

const updatePartnerSiteList = (data) => ({ type: UPDATE_PARTNER_SITE_LIST, list: data })
const fetchPartnerSites = (segment, line) => ({ type: FETCH_PARTNER_SITES, segment, line })
const fetchPartnerSitesStart = () => ({ type: FETCH_PARTNER_SITES_START, isLoading: true })
const fetchPartnerSitesSuccess = () => ({ type: FETCH_PARTNER_SITES_SUCCESS, isLoading: false })
const fetchPartnerSitesError = (error) => ({ type: FETCH_PARTNER_SITES_ERROR, error, isLoading: false })

const updateSegmentList = (data) => ({ type: UPDATE_SEGMENT_LIST, segments: data })
const updateLineList = (data) => ({ type: UPDATE_LINE_LIST, lines: data })
const fetchSegmentLine = () => ({ type: FETCH_SEGMENT_LINE })
const fetchSegmentLineStart = () => ({ type: FETCH_SEGMENT_LINE_START })
const fetchSegmentLineSuccess = () => ({ type: FETCH_SEGMENT_LINE_SUCCESS })
const fetchSegmentLineError = (error) => ({ type: FETCH_SEGMENT_LINE_ERROR, error })

const postPartnerSite = () => ({ type: POST_PARTNER_SITE })
const postPartnerSiteStart = () => ({ type: POST_PARTNER_SITE_START })
const postPartnerSiteSuccess = () => ({ type: POST_PARTNER_SITE_SUCCESS })
const postPartnerSiteError = (error) => ({ type: POST_PARTNER_SITE_ERROR, error })

const updateAeRegionList = (data) => ({ type: UPDATE_AE_REGION_LIST, aeRegions: data })
const fetchAeRegionList = () => ({ type: FETCH_AE_REGION_LIST })
const fetchAeRegionListStart = () => ({ type: FETCH_AE_REGION_LIST_START })
const fetchAeRegionListSuccess = () => ({ type: FETCH_AE_REGION_LIST_SUCCESS })
const fetchAeRegionListError = (error) => ({ type: FETCH_AE_REGION_LIST_ERROR, error })


const fetchPartnerSitesHelper = () => {
  return (dispatch, getState) => {
    const segment = segmentSelector(getState())
    const line = lineSelector(getState())
    if (segment.length >= 1 && line.length >= 1) return dispatch(fetchPartnerSites(segment, line))
  }
}

export {
  updatePartnerSite,
  updateSegment,
  updateLine,
  updatePartnerName,
  updateOdm,
  updateCustomerClass,
  updateSegmentList,
  updateLineList,
  updateAeRegion,
  fetchAeRegionStart,
  fetchAeRegionSuccess,
  fetchAeRegionError,
  fetchSegmentLine,
  fetchSegmentLineStart,
  fetchSegmentLineSuccess,
  fetchSegmentLineError,
  updatePartnerSiteList,
  fetchPartnerSites,
  fetchPartnerSitesStart,
  fetchPartnerSitesSuccess,
  fetchPartnerSitesError,
  postPartnerSite,
  postPartnerSiteStart,
  postPartnerSiteSuccess,
  postPartnerSiteError,
  fetchPartnerSitesHelper,
  fetchAeRegionList,
  fetchAeRegionListStart,
  fetchAeRegionListSuccess,
  fetchAeRegionListError,
  updateAeRegionList
}
